import { useState } from "react";
import { useCookies } from "react-cookie";
import axios from "axios";
import "./login_page.css";
import { useNavigate } from "react-router-dom";

function LoginPage() {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [cookie, setCookie] = useCookies(["admin"]);
  const navigate = useNavigate();

  const handleIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setId(event.target.value);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const handleLogin = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const loginAPI = process.env.REACT_APP_SERVER_URI + "/auth/login";

    axios
      .post(
        loginAPI,
        { id, password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        console.log("data?", res.data);
        const { result, message, token, expireSec } = res.data;

        if (result) {
          const expires = new Date();
          expires.setTime(expires.getTime() + Number(expireSec) * 1000);
          console.log("expire ", expires);
          setCookie("admin", token, {
            expires,
            path: "/",
          });

          console.log(message);
          alert(message);

          navigate("/");
        } else {
          console.log(message);
          alert(message);
        }
      })
      .catch((error) => {
        console.error(error);
        alert(error.message);
      });
  };

  return (
    <div className="login_page">
      <div className="login-container">
        <div className="login-title">로그인</div>
        <div className="form-wrapper">
          <form>
            <div className="form-group">
              <label className="form-label">아이디</label>
              <input
                id="id"
                className="form-input"
                type="id"
                value={id}
                onChange={handleIdChange}
              />
            </div>
            <div className="form-group">
              <label className="form-label">비밀번호</label>
              <input
                id="password"
                className="form-input"
                type="password"
                value={password}
                onChange={handlePasswordChange}
              />
            </div>
            <div>
              <button
                type="submit"
                className="form-submit"
                onClick={handleLogin}
              >
                로그인
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
